import { reducer, actions } from "./ducks";
import page from "./_AuthPage/_AuthPage";
import saga from "./saga";
import { Feature } from "features/interfaces";

export const authFeature: Feature<typeof actions> = {
  reducer,
  saga,
  actions,
  page
};
